import * as Components from "./components";

export default class Base {
  game_state = "prelude"; // prelude|play|stop
  game_will_end_at = null;
  score = { fruit: 0, red_pocket: 0, coin: 0 };

  constructor(
    {
      options: {
        red_pocket_count,
        fruit_count,
        coin_count,
        red_pocket_speed,
        fruit_speed,
        coin_speed,
        game_duration,
        game_prelude_duration,
        gravity
      },
      assets: {
        background,
        redpocket,
        fruit,
        coin,
        catch_effect,
        blanket,
        count,
        board,
        gameover
      }
    },
    { onGameover = () => {}, onTapGameover = () => {} }
  ) {
    this.assets = {
      background,
      redpocket,
      fruit,
      coin,
      catch_effect,
      blanket,
      count,
      board,
      gameover
    };

    this.red_pocket_count = red_pocket_count || this.red_pocket_count;
    this.fruit_count = fruit_count || this.fruit_count;
    this.coin_count = coin_count || this.coin_count;
    this.red_pocket_speed = red_pocket_speed;
    this.fruit_speed = fruit_speed;
    this.coin_speed = coin_speed;
    this.game_duration = (game_duration || this.game_duration) * 1000 + 100;
    this.game_prelude_duration =
      game_prelude_duration || this.game_prelude_duration;
    this.gravity = gravity || this.gravity;

    this.loadPreludeScence = Components.loadPreludeScence.bind(this);
    this.loadGameScence = Components.loadGameScence.bind(this);
    this.loadGameoverScence = Components.loadGameoverScence.bind(this);
    this.loadMask = Components.loadMask.bind(this);
    this.loadBlanket = Components.loadBlanket.bind(this);
    this.loadContainer = Components.loadContainer.bind(this);
    this.loadDrops = Components.loadDrops.bind(this);
    this.hitTest = this.hitTest.bind(this);
    this.play = this.play.bind(this);
    this.finish = this.finish.bind(this);
    this.reset = this.reset.bind(this);

    this.onTapGameover = onTapGameover;
    this.onGameover = onGameover;

    this.destroy = this.destroy.bind(this);
  }
}
